import {
  Button,

  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,

  Skeleton,
  cn
} from '@yakit/ui-components';

import { useDefaultIframe } from '@VDL/hooks/useDefaultIframe';
import { LoaderCircle } from 'lucide-react';
import { useState } from 'react';

export const VLDIframeModal = ({ onClose }: { onClose: () => void }) => {
  const { defaultIframe, setDefaultIframe, loaded, setLoaded } =
    useDefaultIframe();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!defaultIframe || defaultIframe.type !== 'withSubmit') return;

    try {
      setIsSubmitting(true);
      await defaultIframe.onSubmit(); // Предполагаем, что onSubmit может быть асинхронным
      setDefaultIframe(null);
      setLoaded(false);
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={defaultIframe != null}
      onOpenChange={(flag) => {
        if (!flag) {
          setDefaultIframe(null);
          setLoaded(false);
          onClose();
        }
      }}
    >
      <DialogContent className="flex h-[90dvh] w-[90dvw] sm:max-w-[90dvw] flex-col">
        <DialogHeader className="shrink-0">
          <DialogTitle>{defaultIframe?.title}</DialogTitle>
        </DialogHeader>
        <div className="relative flex-1">
          <div className="absolute h-full w-full">
            {!loaded  && <Skeleton className="h-full w-full" />}
            {defaultIframe && (
              <iframe
                className={cn('absolute h-full w-full', { hidden: !loaded })}
                src={import.meta.env.DEV ? `https://yakit.pro/sc${defaultIframe.src}` : defaultIframe.src}
                onLoad={() => setLoaded(true)}
              />
            )}
          </div>
        </div>
        {defaultIframe?.type === 'withSubmit' && (
          <DialogFooter>
            <Button onClick={handleSubmit} disabled={isSubmitting}>
              {isSubmitting ? (
                <span className="flex items-center gap-2">
                  {defaultIframe.submitTitle}
                  <LoaderCircle className="ml-2 h-4 w-4" />
                </span>
              ) : (
                defaultIframe.submitTitle
              )}
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
